import React, { useEffect, useState } from 'react'
import { Stats } from '../../../components/Dashboard/Stats'
import { userService } from '../../../services/user.service'
import { useParams } from 'react-router-dom'

export const AccountStats = () => {
  const { idEvento } = useParams()
  console.log(idEvento)
  const [publications, setPublications] = useState([])
  useEffect(() => {
    const getAllReservations = async () => {
      try {
        const reservaciones = await userService.getAllStats(idEvento)
        setPublications(reservaciones)
      } catch (error) {
        console.log(error)
      }
    }
    getAllReservations()
  }, [])
  console.log(publications)
  return (
    <>
      {/* Account collections */}
      <div className="pb-5 mb-lg-2 mt-md-0">
        <div className="ps-md-3 ps-lg-0 mt-md-2 pt-md-4 pb-md-2">
          {
            publications.map((pub, index) => (<Stats key={index}{...pub}/>))
          }
        </div>
      </div>

    </>
  )
}
